import {
  DazzlingRadiance,
  DefendToTheLast,
  DriveThemBack,
  HawkOfTheCelestialStrike,
  LightningStrikeArrival,
  StormcastEternalsYndrastaSpearhead,
  StrikeWithTheTempestRage,
  ThePrimeHuntress
} from "whole-shared";

import type { ClientAbility } from "../../rules";
import type { ClientSpearheadArmy } from "./rules";

export const ClientLightningStrikeArrival: ClientAbility = {
  ...LightningStrikeArrival,
  description: "With a clap of thunder, Yndrasta and her allies strike down onto the battlefield",
  effect:      "Set up this unit anywhere on the battlefield more than 6\" from all enemy units",
  name:        "LIGHTNING-STRIKE ARRIVAL"
};

export const ClientThePrimeHuntress: ClientAbility = {
  ...ThePrimeHuntress,
  description: "Yndrasta relishes hunting the mightiest and most terrifying quarry",
  effect:      (
    <>
      The Damage characteristic of <b>Thengavar</b> (Yndrasta's spear) is 2D6 for attacks that target a <b>Monster</b>
    </>
  ),
  name: "THE PRIME HUNTRESS"
};

export const ClientStrikeWithTheTempestRage: ClientAbility = {
  ...StrikeWithTheTempestRage,
  description: "Yndrasta's enemies know that to catch her gaze is to be marked for annihilation",
  effect:      (
    <>
      Your general has <b>Strike-first</b> if they charged in the same turn
    </>
  ),
  name: "STRIKE WITH THE TEMPEST'S RAGE"
};

export const ClientDazzlingRadiance: ClientAbility = {
  ...DazzlingRadiance,
  declare:     "Pick your general to use this ability if they were set up this phase",
  description: "Yndrasta's god-touched brilliance can call stranded Stormcast souls into the fray once more",
  effect:      "You can return 1 slain model to each friendly unit wholly within 12\" of your general",
  name:        "DAZZLING RADIANCE"
};

export const ClientHawkOfTheCelestialStrike: ClientAbility = {
  ...HawkOfTheCelestialStrike,
  description: "The sight of Yndrasta's seraphic form inspires her warriors with immeasurable resolve",
  effect:      "Until the end of the phase, add 1 to hit rolls for attacks made by friendly units while they are wholly within 12\" of your general",
  name:        "HAWK OF THE CELESTIAL SKIES"
};

export const ClientDriveThemBack: ClientAbility = {
  ...DriveThemBack,
  declare:     "Pick any number of friendly units that are both contesting an objective and in combat",
  description: "Not an inch is given to the enemies of Sigmar",
  effect:
    ": Each of those units can make a pile-in move (Core Rules, 15.3). For each unit that did so, pick an enemy unit within 1\" of it and roll a dice. On a 4+, inflict 1 mortal damage on that enemy unit",
  name: "DRIVE THEM BACK"
};

export const ClientDefendToTheLast: ClientAbility = {
  ...DefendToTheLast,
  description: "These fearless warriors refuse to fall until their task is completed",
  effect:      (
    <>
      Friendly units have <b>Ward (6+)</b> while they are contesting an objective you control
    </>
  ),
  name: "DEFEND TO THE LAST"
};

export const ClientStormcastEternalsYndrastaSpearhead: ClientSpearheadArmy = {
  ...StormcastEternalsYndrastaSpearhead,
  battleTraits:      [ClientLightningStrikeArrival],
  enhancements:      [ClientThePrimeHuntress, ClientStrikeWithTheTempestRage, ClientDazzlingRadiance, ClientHawkOfTheCelestialStrike],
  name:              "YNDRASTA'S SPEARHEAD",
  regimentAbilities: [ClientDriveThemBack, ClientDefendToTheLast]
};
